const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  drop: {
    flex: 1,
  },
};

export default styles;
